import { render, staticRenderFns } from "./orderReady.vue?vue&type=template&id=b47d0818&scoped=true&"
import script from "./orderReady.vue?vue&type=script&lang=js&"
export * from "./orderReady.vue?vue&type=script&lang=js&"
import style0 from "./orderReady.vue?vue&type=style&index=0&id=b47d0818&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b47d0818",
  null
  
)

export default component.exports